import map from 'lodash/map';
import sortBy from 'lodash/sortBy';

import businessHoursResource from 'src/actions/businessHours/businessHoursResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

export default function useBusinessHours() {
  const { loadingState, values = [] } = useResourceValues(businessHoursResource);
  return {
    loadingState,
    values: sortBy(
      map(values, ({ id, name }) => {
        return { label: name, value: id };
      }),
      ['label']
    ),
  };
}
